// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1793640837651
      var cssReload = require("/home/ec2-user/Lattice-web-app/node_modules/.pnpm/mini-css-extract-plugin@2.4.7_webpack@5.107.2_@swc+core@1.15.8_@swc+helpers@0.5.18__postcss@8.5.23_/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  